import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./auths/auths.routes').then((m) => m.AUTHS_ROUTES),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
